// store/index.js

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		name: "",
		email: "",
		settings: {
			mic: true,
			camera: true,
		},
		videoDeviceSelected: "",
		audioDeviceSelected: "",
		outputDeviceSelected: "",
		meetingDetails: {},
	},
	mutations: {
		setName(state, name) {
			state.name = name;
		},
		setEmail(state, email) {
			state.email = email;
		},
		setSettings(state, settings) {
			state.settings = settings;
		},
		setVideoDeviceSelected(state, device) {
			state.videoDeviceSelected = device;
		},
		setAudioDeviceSelected(state, device) {
			state.audioDeviceSelected = device;
		},
		setOutputDeviceSelected(state, device) {
			state.outputDeviceSelected = device;
		},
		setMeetingDetails(state, details) {
			state.meetingDetails = details;
		},
	},
	actions: {
		updateName({ commit }, name) {
			commit("setName", name);
		},
		updateEmail({ commit }, email) {
			commit("setEmail", email);
		},
		updateSettings({ commit }, settings) {
			commit("setSettings", settings);
		},
		updateVideoDevice({ commit }, device) {
			commit("setVideoDeviceSelected", device);
		},
		updateAudioDevice({ commit }, device) {
			commit("setAudioDeviceSelected", device);
		},
		updateOutputDevice({ commit }, device) {
			commit("setOutputDeviceSelected", device);
		},
	},
	getters: {
		getName: (state) => state.name,
		getEmail: (state) => state.email,
		getSettings: (state) => state.settings,
		getVideoDeviceSelected: (state) => state.videoDeviceSelected,
		getAudioDeviceSelected: (state) => state.audioDeviceSelected,
		getOutputDeviceSelected: (state) => state.outputDeviceSelected,
		getMeetingDetails: (state) => state.meetingDetails,
	},
});
